/* eslint "no-underscore-dangle": "off" */
import omit from 'just-omit';
import loadNamespaces from 'next-translate/loadNamespaces';
import { i18n } from '@/config';

export default async function fetchAndUseI18n(
  lang: string,
  pathname: string | null = null
) {
  if (pathname) {
    const translations = await loadNamespaces({
      ...i18n,
      locale: lang,
      pathname
    });

    globalThis.__NEXT_TRANSLATE__ = {
      lang,
      config: i18n,
      namespaces: {
        ...(globalThis.__NEXT_TRANSLATE__
          ? globalThis.__NEXT_TRANSLATE__.namespaces
          : {}),
        ...(translations.__namespaces ?? {})
      }
    };
  } else {
    const namespaces = i18n.pages['*'];
    const translations = await Promise.all(
      namespaces.map((ns) => i18n.loadLocaleFrom(lang, ns))
    );

    globalThis.__NEXT_TRANSLATE__ = {
      lang,
      config: i18n,
      namespaces: {
        ...(globalThis.__NEXT_TRANSLATE__
          ? globalThis.__NEXT_TRANSLATE__.namespaces
          : {}),
        ...Object.fromEntries(
          namespaces.map((ns, index) => [ns, translations[index]])
        )
      }
    };
  }

  return {
    lang: globalThis.__NEXT_TRANSLATE__.lang,
    namespaces: globalThis.__NEXT_TRANSLATE__.namespaces,
    config: globalThis.__NEXT_TRANSLATE__.config,
    clientConfig: omit(globalThis.__NEXT_TRANSLATE__.config, 'loadLocaleFrom')
  };
}
